import Typography from '~/shared/components/Typography';

export default function FilterPanelHeader() {
  return (
    <div className="flex justify-between items-center px-8 py-6">
      <Typography
        variant="H3-med-resp"
        fontWeight={500}
        className="font-family-outfit text-primary-900"
      >
        Filters
      </Typography>
    </div>
  );
}
